import React, { useContext, useMemo } from "react";
import { BBVAFinancing } from "./BBVAFinancing/web";
import { ItauFinancing } from "./ItauFinancing/web";
import { ConfigStateContext } from "../../Contexts/Configurations/context";
import { isRent, isSell } from "../../Utils/Functions";
import { MapfreFinancing } from "./MapfreFinancing/web";
import "./styles.less";
import CredifamiliaFinancing from "./CredifamiliaFinancing/web";
import {
	CITIES,
	DEPARTMENTS,
	MAX_VALUE,
	MIN_VALUE,
	STRATUM,
} from "./CredifamiliaFinancing/constants";
import usePropertyData from "src/hooks/propertyData/usePropertyData";

const PROPERTY_TYPE_NOT_TO_BE_DISPLAYED = 3;
const MIN_PROPERTY_PRICE = 37000;

const IsPriceToConsult = price =>
	!price?.currency || !price || price.amount == 0 || (price?.isTemp && price?.amount < 5);

export const Financing = ({
	operationType,
	id,
	propertyType,
	propertyPrice,
	isDisabledProperty = false,
	reference = "",
	financingRef = null,
	showFinancingCard = false,
}) => {
	const { country_code } = useContext(ConfigStateContext);
	const { listing } = usePropertyData();

	/* Credifamilia segmentation */
	const calcAge = new Date().getFullYear() - listing?.construction_year;
	const isBogota = listing?.locations?.city?.[0]?.name === "Bogotá";
	const isDepartment = DEPARTMENTS.includes(listing?.locations?.state?.[0]?.id) || isBogota;
	const isCity = CITIES.includes(listing?.locations?.city?.[0]?.id);
	const isStratum = STRATUM.includes(listing?.stratum);
	const isApartment = listing?.technicalSheet?.[1]?.value === "Apartamento";
	const isAge = calcAge > 0 && calcAge <= 30;
	const isPrice = listing?.price?.amount >= MIN_VALUE && listing?.price?.amount <= MAX_VALUE;
	const showCredifamilia = useMemo(
		() => isDepartment && isCity && isStratum && isApartment && isAge && isPrice,
		[listing]
	);

	return (
		<>
			{isSell(operationType) &&
			country_code == "UY" &&
			propertyPrice &&
			propertyPrice.amount &&
			propertyType &&
			propertyType != PROPERTY_TYPE_NOT_TO_BE_DISPLAYED &&
			propertyPrice.amount >= MIN_PROPERTY_PRICE &&
			!propertyPrice.hidePrice &&
			!IsPriceToConsult(propertyPrice) ? (
				<BBVAFinancing
					id={id}
					isDisabledProperty={isDisabledProperty}
					showFinancingCard={showFinancingCard}
					financingRef={financingRef}
				/>
			) : null}
			{isRent(operationType) &&
			country_code == "UY" &&
			propertyPrice &&
			propertyPrice.amount &&
			!propertyPrice.hidePrice &&
			!IsPriceToConsult(propertyPrice) ? (
				<MapfreFinancing
					id={id}
					propertyType={propertyType}
					isDisabledProperty={isDisabledProperty}
					showFinancingCard={showFinancingCard}
					financingRef={financingRef}
				/>
			) : null}
			{isSell(operationType) && country_code == "PY" && (
				<ItauFinancing
					id={id}
					isDisabledProperty={isDisabledProperty}
					showFinancingCard={showFinancingCard}
					financingRef={financingRef}
				/>
			)}
			{country_code === "CO" && showCredifamilia && (
				<CredifamiliaFinancing
					showFinancingCard={showFinancingCard}
					financingRef={financingRef}
					price={propertyPrice.amount}
				/>
			)}
		</>
	);
};

